<div mat-dialog-title class="row">
  <div class="col-12">
    <h1>{{ 'Private.TransferParticipants.Title' | translate }}</h1>
  </div>
</div>

<mat-dialog-content>
  <div class="row mb-3">
    <div class="col-12">
      <span>{{ currentDateTitle }}</span>
    </div>
  </div>

  <form [formGroup]="formGroup" autocomplete="false">
    <div class="row mt-3 mb-2">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Private.TransferParticipants.Participants' | translate }}</mat-label>
          <mat-select panelClass="picker-options" [formControl]="participantIdsControl" multiple>
            @for (group of groups; track group) {
              <mat-option [value]="group">
                {{ group.groupPersons[0].person.prename }} {{ group.groupPersons[0].person.surname }} ({{ group.size }})
              </mat-option>
            }
          </mat-select>
          @if (targetDateIdControl.hasError('required')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.Required' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      @if (!groupId) {
        <div class="col-12 mb-2">
          <mat-checkbox [formControl]="selectAllControl">
            {{ 'Private.TransferParticipants.SelectAll' | translate }}
          </mat-checkbox>
        </div>
      }
    </div>

    <div class="row mt-2 mb-4">
      <div class="col-12">
        <span>{{ 'Private.TransferParticipants.CurrentDate' | translate }}: {{ currentDate?.start |
        date:'dd.MM.yyy HH:mm' }}</span>
      </div>
      <div class="col-12">
        <span>{{ 'Private.TransferParticipants.CurrentParticipants' | translate }}: {{ numberOfRegistrations }}</span>
      </div>
    </div>

    <div class="row mt-4 mb-2">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Private.TransferParticipants.TargetDate' | translate }}</mat-label>
          <mat-select panelClass="picker-options" [formControl]="targetDateIdControl">
            @for (date of dates; track date) {
              <mat-option [value]="date.id">
                {{ date.start | date:'dd.MM.yyy HH:mm' }}
              </mat-option>
            }
          </mat-select>
          @if (targetDateIdControl.hasError('required')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.Required' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    @if (targetDateIdControl.value && targetDate && currentDate) {
      <div class="row">
        <div class="col-12" >
          <span>{{ 'Private.TransferParticipants.OldCapacity' | translate }}: {{ targetDate.numberOfRegistrations
          + targetDate.numberOfRegistrationsSingle }}</span>
        </div>
        <div class="col-12">
          <span
            [ngClass]="{ 'warn' : targetDate.numberOfRegistrations + targetDate.numberOfRegistrationsSingle + numberOfRegistrations >  targetDate.maxRegistrations + targetDate.maxRegistrationsSingle }">{{
            'Private.TransferParticipants.NewCapacity' | translate }}: {{ targetDate.numberOfRegistrations +
          targetDate.numberOfRegistrationsSingle + numberOfRegistrations }}</span>
        </div>
        <div class="col-12">
          <span>{{ 'Private.TransferParticipants.Contingent' | translate }}: {{ targetDate.maxRegistrations +
          targetDate.maxRegistrationsSingle }}</span>
        </div>
      </div>
    }

    <div class="row mt-2 mb-1">
      <div class="col-12">
        <div class="custom-stepper-buttons">
          <button mat-raised-button color="basic" (click)="onCancel()">{{ 'Common.Cancel' | translate
          }}</button>
          <button mat-raised-button color="primary" class="ms-3" (click)="submit()" [disabled]="!targetDateIdControl.value || numberOfRegistrations == 0">{{ numberOfRegistrations }} {{ 'Common.TransferParticipant' |
            translate
          }}</button>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>